var map = {
	"./404.png": 74875,
	"./add-product-group.svg": 67560,
	"./admin.svg": 21909,
	"./ai-insights-disabled.svg": 15793,
	"./ai-insights.svg": 75448,
	"./alert-bell-black.svg": 88023,
	"./alert-bell-blue.svg": 19976,
	"./alert-bell-red.svg": 26317,
	"./alert-bell.svg": 75760,
	"./all-skus-black.svg": 51270,
	"./all-skus-blue.svg": 4396,
	"./amazon-aplus-blue.svg": 29556,
	"./amazon-aplus.svg": 95145,
	"./analysis.svg": 19556,
	"./ap-screen-icon.svg": 6093,
	"./arrow-down-red.svg": 89593,
	"./arrow-navigation.svg": 74716,
	"./arrow-up-green.svg": 18935,
	"./arrow_1.png": 73014,
	"./arrows-up-down.svg": 22957,
	"./ascending.svg": 14205,
	"./attention.svg": 75627,
	"./average-rating-black.svg": 59104,
	"./average-rating-blue.svg": 65841,
	"./avg-rating-star.svg": 53313,
	"./backend-error-msg.svg": 36474,
	"./bar-chart.svg": 41578,
	"./bd-white-logo.svg": 60387,
	"./bg-global.png": 13545,
	"./bg-login.png": 17629,
	"./bg-logout.svg": 70155,
	"./bi-logo-big.png": 20415,
	"./bi-logo.png": 67911,
	"./binoculars-icon.svg": 80805,
	"./bitmap.jpg": 71299,
	"./blue-admin.png": 65520,
	"./blue-calendar.svg": 34887,
	"./blue-chevron.svg": 81244,
	"./blue-compare-arrows.svg": 63768,
	"./bookmark-black-outline.svg": 83424,
	"./bookmark-blue.svg": 42438,
	"./bookmark-filled.svg": 40702,
	"./bookmark-outline.svg": 2635,
	"./brand-performance-button.svg": 18447,
	"./brand-performance.svg": 78349,
	"./card-view-icon.svg": 94727,
	"./categories.svg": 44460,
	"./check-black.svg": 77390,
	"./check.svg": 87391,
	"./checkbox-checked.svg": 53594,
	"./checkbox.svg": 35615,
	"./checkmark.svg": 62675,
	"./chevron-left.svg": 30905,
	"./chevron-nav-icon.svg": 17794,
	"./chevron.svg": 33813,
	"./competitive-retail-tracker.svg": 59155,
	"./copy-button-hover.svg": 65815,
	"./copy-button.svg": 65164,
	"./custom-black.svg": 97684,
	"./custom-blue.svg": 60092,
	"./custom-trigger-icon.svg": 55090,
	"./delete-trash-black.svg": 20425,
	"./delete-trash.svg": 83102,
	"./delete-view.svg": 8328,
	"./descending.svg": 56275,
	"./digital-content-blue.svg": 43305,
	"./digital-content.svg": 86495,
	"./down-arrow.png": 80056,
	"./down-arrow.svg": 74971,
	"./dropdown-selected.svg": 88937,
	"./dropdown.svg": 42316,
	"./edit-columns.svg": 1534,
	"./edit-columns_1.svg": 64110,
	"./email-sent.png": 75521,
	"./entity-exclude.svg": 12443,
	"./entity-filter.svg": 34001,
	"./entity-market-share-analysis.svg": 53777,
	"./entity-view-360.svg": 91245,
	"./entity-view-skus.svg": 2822,
	"./error-insights.svg": 32471,
	"./error-visual.svg": 24187,
	"./exclude-notifications.svg": 94453,
	"./export.svg": 17831,
	"./eye-visibility-off.svg": 56414,
	"./eye-visibility-on.svg": 15180,
	"./filter-icon-2.svg": 69703,
	"./filter-icon.svg": 86031,
	"./grey-calendar.svg": 31286,
	"./grey-chevron.svg": 78889,
	"./grey-compare-arrows.svg": 5309,
	"./horizontal-rectangle.svg": 11304,
	"./info-circle.svg": 74705,
	"./info-error-msg.svg": 42478,
	"./info.svg": 58686,
	"./insights-ai-full-insights.svg": 85013,
	"./insights-ai-summary.svg": 60704,
	"./insights-board-category.svg": 5518,
	"./insights-board-your-brand.svg": 6633,
	"./insights-board.svg": 23755,
	"./insights-light.png": 63164,
	"./insights-nav-icon.svg": 24270,
	"./insights.svg": 18837,
	"./item-menu.svg": 70304,
	"./like-active.svg": 86634,
	"./like-hover.svg": 38301,
	"./like-normal.svg": 79496,
	"./limit-notifications.svg": 64419,
	"./line-chart.svg": 69529,
	"./link-box.svg": 60303,
	"./link.png": 87467,
	"./link@2x.png": 48194,
	"./link@3x.png": 10081,
	"./list.svg": 67815,
	"./load-blue.svg": 7081,
	"./load.svg": 54961,
	"./logo-vert.png": 83550,
	"./logo.png": 42904,
	"./logout-icon.svg": 35930,
	"./logout-illus.svg": 64487,
	"./logout.svg": 63024,
	"./magic-big.jpg": 47183,
	"./market_share.svg": 22644,
	"./missing-inventory.svg": 91136,
	"./ms-screen-icon.svg": 20849,
	"./new_sku.svg": 25172,
	"./no-category-selected.svg": 87864,
	"./no-data-error-msg.svg": 77457,
	"./no-events.svg": 35288,
	"./no-image-placeholder-medium.svg": 58052,
	"./no-image-placeholder-small.svg": 80035,
	"./no-image-tooltip.svg": 47784,
	"./no-triggers.svg": 78765,
	"./on-promo-black.svg": 23010,
	"./on-promo-blue.svg": 56425,
	"./oos-black.svg": 49815,
	"./oos-blue.svg": 93277,
	"./orphaned_sku.svg": 5171,
	"./password-reset.png": 25145,
	"./pencil.svg": 61074,
	"./pie-chart-icon.svg": 2708,
	"./placeholder.png": 40382,
	"./price-drops-black.svg": 84310,
	"./price-drops-blue.svg": 73997,
	"./price-gains-blue.svg": 98293,
	"./price-gains.svg": 47593,
	"./price-index-blue.svg": 83706,
	"./price-index.svg": 34952,
	"./product-group-placeholder.jpg": 25843,
	"./products-groups-dark.svg": 64334,
	"./products-groups.svg": 61059,
	"./rank-gains-blue.svg": 62902,
	"./rank-gains.svg": 4096,
	"./ranking-events-negative-review.svg": 10884,
	"./ranking-events-oos.svg": 92678,
	"./ranking-events-rating-drops.svg": 1924,
	"./ranking-events-visibility-drops.svg": 22713,
	"./ranking-events-visibility-gains.svg": 44634,
	"./ranking.svg": 98865,
	"./rankingEvents-has-rank.svg": 30142,
	"./rankingEvents-not-available.svg": 89572,
	"./rankingEvents-rank-drop.svg": 9341,
	"./rankingEvents-rank-gain.svg": 73998,
	"./rating-drops-black.svg": 7831,
	"./rating-drops-blue.svg": 93825,
	"./rating-star-blue.svg": 13550,
	"./rating-star.svg": 74683,
	"./re-screen-icon.svg": 79853,
	"./rectangle.svg": 13800,
	"./retailer-margins-black.svg": 61100,
	"./retailer-margins-blue.svg": 71646,
	"./sales-share-nav-icon.svg": 49515,
	"./sales-voumes.svg": 77221,
	"./save-view-as.svg": 59103,
	"./save-view-dropdown.svg": 33623,
	"./save-view.svg": 28867,
	"./save.svg": 95657,
	"./search-icon.png": 80591,
	"./search.svg": 17240,
	"./select-view-dropdown.svg": 88168,
	"./settings.svg": 89277,
	"./share.svg": 24570,
	"./share_black.svg": 37017,
	"./sort-down-hover-red.svg": 23278,
	"./sort-down-hover.svg": 40446,
	"./sort-down.png": 91358,
	"./sort-up-down-hover-red.svg": 99168,
	"./sort-up-down-hover.svg": 15503,
	"./sort-up-down.png": 57240,
	"./sort-up-hover-blue.svg": 61633,
	"./sort-up-hover-red.svg": 72986,
	"./sort-up-hover-white.svg": 87072,
	"./sort-up-hover.svg": 35049,
	"./sponsored-blue.svg": 10605,
	"./sponsored.svg": 16,
	"./st-screen-icon.svg": 43225,
	"./storefront-black.svg": 61514,
	"./storefront-blue.svg": 74490,
	"./switch-off.svg": 65832,
	"./switch-on.svg": 16766,
	"./table-view-icon.svg": 10010,
	"./tag.svg": 2824,
	"./tip-icon.svg": 22883,
	"./top-gainers-black.svg": 86059,
	"./top-gainers-blue.svg": 65922,
	"./top-losers-black.svg": 99466,
	"./top-losers-blue.svg": 96875,
	"./top-movers.svg": 66507,
	"./top-sellers-black.svg": 41015,
	"./top-sellers-blue.svg": 30967,
	"./top-skus.svg": 66774,
	"./top-trending-black.svg": 60940,
	"./top-trending-blue.svg": 83225,
	"./top_sku-icon-main.png": 60768,
	"./tracking-nav-icon.svg": 84307,
	"./traffic.svg": 38074,
	"./trash.svg": 47315,
	"./triggers-default.svg": 52684,
	"./unlisted-black.svg": 71381,
	"./unlisted-blue.svg": 97108,
	"./user-nav-icon.svg": 94067,
	"./variant-separation.svg": 61232,
	"./visibility-drops-blue.svg": 33229,
	"./visibility-drops.svg": 31069,
	"./visibility-gains-blue.svg": 29570,
	"./visibility-gains.svg": 29340,
	"./visibility.svg": 22527,
	"./x-white.svg": 44059,
	"./x.svg": 39960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29517;